import React from 'react';
import {
  Box,
  TableRow,
  TableCell,
  Collapse,
  CircularProgress,
  Typography,
  TableBody,
  IconButton,
  Table,
  Tooltip,
} from '@material-ui/core';
import Excel from 'assets/icons/svg/Excel';
import moment from 'moment';
import { ICriteriaRating, IRealEstateRatingByPartner } from '../../../interfaces';
import PartnerRatingColGroup from './PartnerRatingColGroup';

interface IProps {
  open: boolean;
  realEstatesRating: IRealEstateRatingByPartner[];
  loading: boolean;
  error: string | null;
  success: boolean;
  exportExcelLoading: boolean;
  criteriaRatingsByServiceType: ICriteriaRating[];
  onExportExcel(): void;
}

const PartnerRatingByMonthTableRow = ({
  open,
  error,
  loading,
  realEstatesRating,
  success,
  exportExcelLoading,
  criteriaRatingsByServiceType,
  onExportExcel,
}: IProps) => {
  return (
    <Box component={TableRow} sx={{ borderBottom: 'unset' }}>
      <TableCell colSpan={criteriaRatingsByServiceType.length + 7} style={{ padding: 0, border: 'none' }}>
        <Collapse in={open} unmountOnExit>
          {Boolean(loading) ? (
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
              <CircularProgress />
            </Box>
          ) : Boolean(error) && !Boolean(realEstatesRating.length) ? (
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
              <Typography component="h3" variant="h5" align="center">
                {error}
              </Typography>
            </Box>
          ) : (
            success && (
              <>
                {realEstatesRating.length ? (
                  <Table size="small" style={{ tableLayout: 'fixed' }}>
                    <PartnerRatingColGroup criteriaCount={criteriaRatingsByServiceType.length} />

                    <TableBody>
                      {realEstatesRating.map(
                        (
                          {
                            criteriaRatings,
                            countPositive,
                            countOvksPositive,
                            countNegative,
                            countOvksNegative,
                            countOvks,
                            actOvks,
                            dateAt,
                          },
                          index,
                        ) => (
                          <TableRow key={index}>
                            <TableCell>
                              <b>{moment(dateAt, 'YYYY-MM').format('MMM')}</b>
                            </TableCell>

                            <TableCell>{countPositive}</TableCell>
                            <TableCell>{countOvksPositive}</TableCell>
                            <TableCell>{countNegative}</TableCell>
                            <TableCell>{countOvksNegative}</TableCell>
                            <TableCell>{countOvks}</TableCell>
                            <TableCell>{actOvks}</TableCell>

                            {criteriaRatingsByServiceType.map((criteriaRating) => {
                              const foundCriteriaRating = criteriaRatings.find(
                                ({ criteriaRatingId }) => criteriaRatingId === criteriaRating.criteriaRatingId,
                              );

                              return (
                                <TableCell key={criteriaRating.criteriaRatingId}>
                                  {foundCriteriaRating?.value ?? '—'}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ),
                      )}
                    </TableBody>
                  </Table>
                ) : (
                  <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                    <Typography component="h3" variant="h5" align="center">
                      Данные отсутствуют
                    </Typography>
                  </Box>
                )}

                <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  {Boolean(realEstatesRating.length) && (
                    <Tooltip title="Скачать отчет в Excel">
                      <span>
                        <IconButton
                          aria-label="Скачать отчет в Excel"
                          onClick={onExportExcel}
                          disabled={loading || exportExcelLoading}
                        >
                          <Excel style={{ color: '#3C763D' }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                </Box>
              </>
            )
          )}
        </Collapse>
      </TableCell>
    </Box>
  );
};

export default PartnerRatingByMonthTableRow;
